<template>
  <Box class="bg-white/90 p-5" rounded="lg">
    <h4
      class="mb-5 font-Kontesa text-[28px] font-bold uppercase leading-none tracking-tight text-navy"
    >
      Leaderboard
    </h4>

    <div class="grid grid-cols-2 gap-3">
      <label
        class="flex h-8 cursor-pointer items-center justify-center rounded-full border border-navy text-[12px] font-bold leading-[14px] text-navy transition-colors has-[:checked]:bg-navy has-[:checked]:text-white 2xl:text-[15px] 2xl:leading-[18px]"
      >
        Global
        <input
          v-model="scope"
          class="appearance-none"
          type="radio"
          name="leaderboard"
          value="global"
        />
      </label>
      <label
        class="flex h-8 cursor-pointer items-center justify-center rounded-full border border-navy text-[12px] font-bold leading-[14px] text-navy transition-colors has-[:checked]:bg-navy has-[:checked]:text-white 2xl:text-[15px] 2xl:leading-[18px]"
      >
        Country
        <input
          v-model="scope"
          class="appearance-none"
          type="radio"
          name="leaderboard"
          value="country"
        />
      </label>
      <label
        class="flex h-8 cursor-pointer items-center justify-center rounded-full border border-navy text-[12px] font-bold leading-[14px] text-navy transition-colors has-[:checked]:bg-navy has-[input:checked]:text-white 2xl:text-[15px] 2xl:leading-[18px]"
      >
        State
        <input
          v-model="scope"
          class="appearance-none"
          type="radio"
          name="leaderboard"
          value="state"
        />
      </label>
      <label
        class="flex h-8 cursor-pointer items-center justify-center rounded-full border border-navy text-[12px] font-bold leading-[14px] text-navy transition-colors has-[:checked]:bg-navy has-[:checked]:text-white 2xl:text-[15px] 2xl:leading-[18px]"
      >
        City
        <input
          v-model="scope"
          class="appearance-none"
          type="radio"
          name="leaderboard"
          value="city"
        />
      </label>
    </div>

    <div class="my-5 border-b border-dashed border-navy" />

    <ProfileLeaderboardTable
      class="w-full"
      :type="type"
      :leaderboard="leaderboards[scope]"
    />
  </Box>
</template>

<script setup lang="ts">
type LeaderboardScope = "global" | "country" | "state" | "city";

defineProps<{
  leaderboards: {
    [key in LeaderboardScope]: {
      id: number | string;
      rank: number;
      name: string;
      family: number;
      points: number;
      highlighted?: boolean;
    }[];
  };
  type: "member" | "partner";
}>();

const scope = ref<LeaderboardScope>("global");
</script>
